import { produce } from 'immer'
import type { State } from '../typings'
import type { LocationDTO } from '@sales-center/common'
import type { SchedulingScreen } from '../../../../typings'
import type { LocAndSvcsFormModel } from '../../../LocAndSvcs'
import type { ILeadOppProduct } from '@user/store/leadOppProducts'

export type ToFiltersAction = {
  type: 'toFilters'
  payload: {
    screen: Extract<SchedulingScreen, 'filters'>
    values: LocAndSvcsFormModel
    serviceLocations: LocationDTO[]
    services: ILeadOppProduct[]
  }
}

export const toFiltersAction = produce<State, [ToFiltersAction['payload']]>(
  (draft, payload) => {
    const { screen, values, services, serviceLocations } = payload
    const { serviceIds, serviceLocationId, serviceType, closeWin } = values

    draft.loading = false
    draft.stack.push(screen)
    draft.response = undefined

    const selectedServices = services.filter((x) => serviceIds.get(x.id))
    const selectedServiceIds = selectedServices.map((s) => `${s.id}`)

    draft.recurringServices = serviceType === 'recurring'

    const selectedLocation = serviceLocations.find(
      (x) => `${x.id}` === serviceLocationId,
    )

    draft.branchId = selectedLocation?.branchId ?? -1
    draft.externalSvcLocId = selectedLocation?.externalLinkId ?? ''

    draft.bestFitInput.serviceIds = selectedServiceIds

    draft.closeOnCommit = draft.canClose && closeWin === 'close'
  },
)

export const toFiltersActionCreator = (
  values: ToFiltersAction['payload']['values'],
  serviceLocations: ToFiltersAction['payload']['serviceLocations'],
  services: ToFiltersAction['payload']['services'],
): ToFiltersAction => ({
  type: 'toFilters',
  payload: {
    values,
    services,
    screen: 'filters',
    serviceLocations,
  },
})
